import * as t from 'io-ts';

import {AnalyticsReportsEnum} from '../../../../analytics/helpers/analyticsReportHelpers';
import {
  RAnalyticsMetricsDictionaryDirty,
  RAnalyticsMetricsKeysDirty,
} from '../../../../models/api/analyticsMetricsModel';
import {RAnalyticsReportFilterOptionsDirty} from '../../../../models/api/analyticsSavedViewModel';
import {makeEnumRuntimeType, RDateTimeString} from '../../../../models/api/apiTypes';

/*
 * Runtime types.
 */

export enum AnalyticsReportJobPrioritiesEnum {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

const RAnalyticsPanelReportJobDirty = t.intersection([
  t.type({
    localId: t.string, // Generated uuid used to find a job in the store when jobUid isn't present (report returned synchronously for instance).
    jobUid: t.union([t.undefined, t.string]), // uuid returned by the backend, used to update the store when update events are pushed to the frontend.
    priority: makeEnumRuntimeType(AnalyticsReportJobPrioritiesEnum),
    metrics: t.readonlyArray(RAnalyticsMetricsKeysDirty),
    isLoading: t.boolean,
    progress: t.number,
    hasStarted: t.boolean,
  }),
  t.partial({
    options: RAnalyticsReportFilterOptionsDirty,
    error: t.string,
    startTime: RDateTimeString,
    endTime: RDateTimeString,
  }),
]);

export const RAnalyticsPanelReportStateDirty = t.type({
  type: makeEnumRuntimeType(AnalyticsReportsEnum),
  jobs: t.readonlyArray(RAnalyticsPanelReportJobDirty),
  metrics: RAnalyticsMetricsDictionaryDirty,
  timedOutMetrics: t.readonlyArray(RAnalyticsMetricsKeysDirty),
  options: RAnalyticsReportFilterOptionsDirty,
});

/*
 * Types.
 */

export interface AnalyticsPanelReportJob extends Readonly<t.TypeOf<typeof RAnalyticsPanelReportJobDirty>> {}

export interface AnalyticsPanelReportState
  extends Readonly<t.TypeOf<typeof RAnalyticsPanelReportStateDirty>> {}
